import {useSelector, useDispatch} from "react-redux";
import constant from "../../store/constant";
import {useEffect} from "react";
import axios from 'axios';
import {Intent, Toaster} from "@blueprintjs/core";
import {Position} from "monaco-editor";

const toaster = Toaster.create({
  position: Position.TOP
});
const useCourseEntry = () => {
  const { catalogs, learnInfo, courseInfos, activeIndexCourseIndex } = useSelector(state => state.courseEntry);
  const dispatch = useDispatch();

  // 初始化课程信息
  useEffect(() => {
    axios.get('/api/course/student_courses').then((response) => {
      const { code, data } = response.data;
      if (code !== 0) {
        return;
      }
      dispatch({
        type: constant.courseEntry.SET_COURSE_INFOS,
        payload: data.map(item => {
          return {
            baseInfo: {
              uid: item.course_uid,
              name: item.name,
              desc: item.desc
            },
            progress: {
              value: item.progress_rate,
              lessonId: item.now_learn_lesson.id,
              lessonNo: item.now_learn_lesson.lesson_no,
              chapterId: item.now_learn_lesson.learn_path_id,
              chapterNo: item.now_learn_lesson.chapter_no,
              title: item.now_learn_lesson.title,
              subtitle: item.now_learn_lesson.title_en,
            }
          }
        })
      });
    });
  }, [dispatch]);

  useEffect(() => {
    if (courseInfos.length === 0) {
      return;
    }
    dispatch({
      type: constant.courseEntry.SET_CATALOGS,
      payload: []
    });
    axios.get('/api/course/chapters', {
      params: {
        course_uid: courseInfos[activeIndexCourseIndex].baseInfo.uid
      }
    }).then((response) => {
      const { code, data } = response.data;
      if (code !== 0) {
        toaster.show({
          message: '目录获取失败，请刷新页面重试',
          timeout: 3000,
          intent: Intent.DANGER
        });
        return;
      }
      dispatch({
        type: constant.courseEntry.SET_CATALOGS,
        payload: data.map(part => ({
          id: part.id,
          title: part.title,
          partNo: part.chapter_no,
          desc: part.summary,
          unlockDate: part.unlock_date,
          permission: part.permission,
          expand: false,
          chapters: (part.learn_paths || []).map(chapter => ({
            id: chapter.id,
            chapterNo: chapter.learn_path_no,
            title: chapter.title,
            type: chapter.learn_path_type,
            lessons: chapter.lessons.map(lesson => ({
              lessonNo: lesson.lesson_no,
              title: lesson.title,
              label: lesson.title_en,
              id: lesson.id,
              status: lesson.finish_status,
              permission: lesson.permission,
              finished: false
            }))
          }))
        }))
      });
    });

  }, [dispatch, courseInfos, activeIndexCourseIndex]);

  useEffect(() => {
    dispatch({
      type: constant.courseEntry.SET_LEARN_INFO,
      payload: {
        loading: true,
      }
    });
    // 获取学习信息
    axios.get('/api/course/student_stat').then(response => {
      const { code, data } = response.data;
      if (code !== 0) {
        // toaster.show({
        //   message: '学习信息获取失败，请刷新页面重试',
        //   timeout: 3000,
        //   intent: Intent.DANGER
        // });
        return;
      }
      dispatch({
        type: constant.courseEntry.SET_LEARN_INFO,
        payload: {
          loading: false,
          learnAllHours: data.learn_all_hour,
          last7Days: data.last_7_day || [],
          severalLearnDays: data.continue_learn_day,
          heatmapData: data.last_200_calendar || []
        }
      });
    });
  }, [dispatch]);

  const handleCollapseCatalog = (index) => {
    dispatch({
      type: constant.courseEntry.EXPAND_CATALOG,
      payload: index
    })
  };
  const handleCourseChange = (index) => {
    dispatch({
      type: constant.courseEntry.SET_ACTIVE_COURSE_INDEX,
      payload: index
    });
    window.localStorage.setItem('active-course-index', index);
  };
  return {
    catalogs,
    learnInfo,
    courseInfos,
    activeIndexCourseIndex,
    handleCollapseCatalog,
    handleCourseChange,
  }
};

export default useCourseEntry;
